
export default function ProjectGallerySection() {
  const projects = [
    {
      title: "Luxury Master Bath Renovation",
      location: "Greenwich, CT",
      contractor: "Elite Bath Solutions",
      image: "https://public.readdy.ai/ai/img_res/73e496f0fff69f14467c11ca468d8128.jpg",
      budget: "$35,000 - $50,000",
      duration: "3 weeks"
    },
    {
      title: "Modern Shower Installation",
      location: "Stamford, CT",
      contractor: "Connecticut Bath Pros",
      image: "https://readdy.ai/api/search-image?query=Modern%20walk-in%20shower%20with%20subway%20tiles%2C%20rainfall%20showerhead%2C%20glass%20doors%2C%20contemporary%20bathroom%20design%2C%20Connecticut%20residential%20project%2C%20professional%20tile%20work%2C%20clean%20modern%20aesthetic&width=400&height=300&seq=project-2&orientation=landscape",
      budget: "$10,000 - $20,000",
      duration: "1 week"
    },
    {
      title: "Guest Bathroom Remodel",
      location: "Hartford, CT",
      contractor: "CT Renovation Experts",
      image: "https://readdy.ai/api/search-image?query=Cozy%20guest%20bathroom%20with%20pedestal%20sink%2C%20classic%20white%20subway%20tiles%2C%20vintage-inspired%20fixtures%2C%20Connecticut%20home%20renovation%2C%20charming%20traditional%20design%2C%20quality%20craftsmanship%2C%20warm%20lighting&width=400&height=300&seq=project-3&orientation=landscape",
      budget: "$15,000 - $25,000",
      duration: "2 weeks"
    },
    {
      title: "Accessible Bathroom Upgrade",
      location: "New Haven, CT",
      contractor: "Accessible Living CT",
      image: "https://readdy.ai/api/search-image?query=Accessible%20bathroom%20with%20walk-in%20shower%2C%20grab%20bars%2C%20comfort%20height%20toilet%2C%20non-slip%20flooring%2C%20Connecticut%20accessibility%20renovation%2C%20safety%20features%2C%20professional%20handicap%20accessible%20design&width=400&height=300&seq=project-4&orientation=landscape",
      budget: "$20,000 - $30,000",
      duration: "2 weeks"
    },
    {
      title: "Spa-Style Master Bath",
      location: "Fairfield, CT",
      contractor: "Luxury Bath Connecticut",
      image: "https://readdy.ai/api/search-image?query=Spa-style%20master%20bathroom%20with%20soaking%20tub%2C%20natural%20stone%20tiles%2C%20ambient%20lighting%2C%20Connecticut%20luxury%20home%2C%20relaxing%20bathroom%20retreat%2C%20high-end%20spa%20features%2C%20professional%20renovation&width=400&height=300&seq=project-5&orientation=landscape",
      budget: "$40,000 - $60,000",
      duration: "4 weeks"
    },
    {
      title: "Small Bath Transformation",
      location: "Waterbury, CT",
      contractor: "Small Space Solutions CT",
      image: "https://readdy.ai/api/search-image?query=Small%20bathroom%20maximized%20with%20space-saving%20fixtures%2C%20corner%20shower%2C%20floating%20vanity%2C%20light%20colors%2C%20Connecticut%20small%20home%20renovation%2C%20efficient%20use%20of%20space%2C%20modern%20compact%20design&width=400&height=300&seq=project-6&orientation=landscape",
      budget: "$8,000 - $15,000",
      duration: "10 days"
    }
  ];

  return (
    <section id="gallery" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Beautiful Bathrooms Across Connecticut
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See the stunning results our verified contractors have delivered for Connecticut homeowners. 
            From luxury renovations to accessibility upgrades, we connect you with the right professional for your vision.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="absolute top-4 left-4 bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-medium">
                  <i className="ri-map-pin-line mr-1"></i>
                  {project.location}
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="font-bold text-gray-900 text-lg mb-2">{project.title}</h3>
                <p className="text-blue-600 font-medium text-sm mb-4">
                  <i className="ri-user-line mr-1"></i>
                  {project.contractor}
                </p>
                
                <div className="space-y-2 text-sm text-gray-600">
                  <div className="flex items-center justify-between">
                    <span className="flex items-center">
                      <i className="ri-money-dollar-circle-line mr-2 text-green-600"></i>
                      Budget:
                    </span>
                    <span className="font-medium">{project.budget}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="flex items-center">
                      <i className="ri-time-line mr-2 text-blue-600"></i>
                      Duration:
                    </span>
                    <span className="font-medium">{project.duration}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="text-center mt-12">
          <div className="inline-flex items-center space-x-4 bg-white rounded-full px-8 py-4 shadow-lg">
            <i className="ri-image-line text-blue-600 text-xl"></i>
            <span className="text-gray-900 font-semibold">500+ Completed Projects in Connecticut</span>
            <span className="text-gray-400">•</span>
            <span className="text-gray-600">All Photos Verified</span>
          </div>
        </div>
      </div>
    </section>
  );
}